// UI mount — Vite serves this as the ES module entry from index.html.
//
// The mount target is the empty `<div id="app">` injected by the HTML
// template; the boot probe in index.html updates document.title with
// `[js-ok]` before this module loads. Svelte's component mount writes
// the router shell (Sidebar + Topbar + main) into #app.

import App from "./App.svelte";

// Load the design tokens, base reset, and component CSS before mount
// so the first paint is already styled. Vite aggregates these into a
// single chunk.
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";

const target = document.getElementById("app");
if (!target) {
  throw new Error("mount target #app missing from index.html");
}

const app = new App({
  target,
});

// Clear the boot probe banner injected by index.html once the SPA has
// mounted successfully. The probe is meant as a fallback that shows
// "JS reached the browser but the bundle didn't load" — once we know
// the bundle loaded AND mounted, hide it. A 1.5 s grace lets the user
// briefly see "mounted" before the banner disappears.
if (typeof window !== "undefined") {
  const banner = (
    window as unknown as { __setBootProbe?: (text: string, bg: string) => void }
  ).__setBootProbe;
  if (banner) {
    banner("rust-dashboard: mounted", "#22c55e");
    setTimeout(() => {
      const el = document.getElementById("boot-probe");
      if (el) el.remove();
    }, 1500);
  }
}

export default app;